import React from "react";
import { useSelector } from "react-redux";
import ProfileDetails from "./ProfileDetails";
import PasswordDetails from "./PasswordDetails";
import BankDetails from "./BankDetails";
import ProfilePicture from "./ProfilePicture";
import { Col, Row } from "reactstrap";
import EmployerInfo from "./EmployerInfo";
import NextOfKin from "./NextOfKin";
import IdCard from "./IDcard";

function Profile() {
  const {
    state,
    firstname,
    lastname,
    middlename,
    profile_pic,
    account_status,
    createdAt,
  } = useSelector((state) => state.auth.user);
  return (
    <>
      {/* {JSON.stringify(user)} */}
      <Row>
        <Col sm={12} md={6} xl={6} className="m-0 p-0">
          <IdCard
            fullName={`${firstname} ${middlename} ${lastname}`}
            idNumber="EMP-789012"
            location={state || "Nig."}
            presidentName="The President Name"
            passportPhoto={profile_pic}
          />
        </Col>
        <Col sm={12} md={6} xl={6}>
          <PasswordDetails />
        </Col>
        <Col sm={12} md={6} xl={6}>
          <ProfileDetails />
        </Col>
        <Col sm={12} md={4} xl={4} className="m-0 p-0">
          <ProfilePicture />
        </Col>
      </Row>

      {/* <Row>
        <Col sm={12} md={6} xl={6}>
          <PasswordDetails />
        </Col>
        <Col sm={12} md={6} xl={6}>
          {" "}
          <BankDetails />
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={6} xl={6}>
          <EmployerInfo />
        </Col>
        <Col sm={12} md={6} xl={6}>
          {" "}
          <NextOfKin />
        </Col>
      </Row> */}
    </>
  );
}

export default Profile;
